// extracted by mini-css-extract-plugin
module.exports = {"pricesTable":"_1z7e6ggJ8m_UvvcDgTUcbx","btnContainer":"_3sSk-EFKJYKbmMqSCwoSgX"};